"use client";
import { SolidFilterFieldsParams } from '../SolidFilterFields';
import SolidIntField from './SolidIntField';

const SolidFloatField = ({ fieldMetadata, onChange, index, rule }: SolidFilterFieldsParams) => {
    return SolidIntField({ fieldMetadata, onChange, index, rule });
};

export default SolidFloatField;